const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreCargoBlockingQuery: any = {
    GetBlockedStores: Backofficebff + '/v1/deliveryservice/get-blocked-stores',
};
